// extracted by mini-css-extract-plugin
export default {"mobile":"ProductTabContent_mobile__1J4vf","tabContainer":"ProductTabContent_tabContainer__YtXIn"};